import React, { createContext, ReactNode, useContext } from 'react';

interface FilterContextType {
	filterComponent: React.ReactNode | null;
	setFilterComponent: (component: React.ReactNode) => void;
	clearFilter: () => void;
}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const FilterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const [filterComponent, setFilterComponent] = React.useState<React.ReactNode | null>(null);

	const clearFilter = React.useCallback(() => {
		setFilterComponent(null);
	}, []);

	const value = React.useMemo(
		() => ({
			filterComponent,
			setFilterComponent,
			clearFilter,
		}),
		[filterComponent, clearFilter]
	);

	return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};

export const useFilter = () => {
	const context = useContext(FilterContext);
	if (context === undefined) {
		throw new Error('useFilter must be used within a FilterProvider');
	}
	return context;
};
